module.exports = __webpack_public_path__ + "static/img/continueModalImg.8675241b.svg";